<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
		className?: string;
		title?: string;
		description?: string;
		linkText?: string;
		linkHref?: string;
	}

	let {
		config,
		className = '',
		title = 'Ready to Get Started?',
		description,
		linkText = 'Sign up now',
		linkHref = '/landing/'
	}: Props = $props();

	// Use custom description or default with brand name
	const ctaDescription = description || `Don't wait to begin your journey with ${config.displayName}.`;
</script>

<div class="cta-section {className}">
	<h2>{title}</h2>
	<p>
		{ctaDescription}
		<a href={linkHref} class="cta-link">{linkText}</a> and start transforming your approach today.
	</p>
</div>

<style>
	.cta-section {
		text-align: center;
		padding: 2rem;
		background: linear-gradient(135deg, var(--brand-primary), var(--brand-secondary));
		color: white;
		border-radius: 12px;
		margin-top: 2rem;
	}

	.cta-section h2 {
		color: white !important;
		margin-bottom: 1rem;
		font-size: 1.75rem;
	}

	.cta-section p {
		color: white !important;
		font-size: 1.1rem;
		margin-bottom: 1.5rem;
		line-height: 1.7;
	}

	.cta-link {
		color: white !important;
		text-decoration: none;
		font-weight: 600;
		border-bottom: 2px solid white;
		transition: all 0.3s ease;
	}

	.cta-link:hover {
		color: rgba(255, 255, 255, 0.8) !important;
		border-bottom-color: rgba(255, 255, 255, 0.8);
	}

	@media (max-width: 768px) {
		.cta-section {
			padding: 1.5rem;
		}

		.cta-section h2 {
			font-size: 1.5rem;
		}
	}
</style>
